import { makeStyles, Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolBar: {
      display: 'flex',
      justifyContent: 'space-between',
      backgroundColor: '#FFF',
      borderBottom: '1px solid #dbdbdb',
      flexWrap: 'wrap',
      padding: theme.spacing(1, 3),
      '& > *': {
        flexGrow: 1,
      },
      '& > :not(:last-child)': {
        margin: theme.spacing(1, 0),
      },
    },
    title: {
      paddingRight: 12,
    },
    search: {
      width: 300,
    },
    clearIcon: {
      width: 20,
      color: 'grey',
    },
    searchIcon: { width: 20 },
    leftToolbarContainer: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
  }),
);

export default useStyles;
